import { render } from "./TheMain.vue?vue&type=template&id=1e72cb01&scoped=true"
import script from "./TheMain.vue?vue&type=script&lang=js"
export * from "./TheMain.vue?vue&type=script&lang=js"

import "./TheMain.vue?vue&type=style&index=0&id=1e72cb01&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e72cb01"]])

export default __exports__